import { Component, inject, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { Observable } from "rxjs"
import { AsyncPipe } from "@angular/common"
import { SeoComponent } from "../../../shared/components/seo/seo.component"
import { MatButtonModule } from "@angular/material/button"
import { TestService } from "../../services/test.service"
import { AgreementComponent } from "../../../shared/components/agreement/agreement.component"
import { ERoutes } from "../../../shared/constants/routes.enum"
import { TERMS_VERSION } from "../../constants/strings"
import { SettingsService } from "../../../shared/services/settings.service"
import { MainStore } from "../../../shared/store/main.store"
import { MainContentComponent } from "../../../shared/components/main-content/main-content.component"
import { SkipLinkComponent } from "../../../shared/components/skip-link/skip-link.component"

@Component({
  selector: "app-terms-conditions-screen",
  templateUrl: "./terms-conditions-screen.component.html",
  styleUrls: ["./terms-conditions-screen.component.scss"],
  imports: [
    AgreementComponent,
    AsyncPipe,
    MatButtonModule,
    MainContentComponent,
    SkipLinkComponent,
  ],
})
export class TermsConditionsScreenComponent
  extends SeoComponent
  implements OnInit
{
  mainStore = inject(MainStore)
  terms$!: Observable<string>
  router = inject(Router)
  service = inject(TestService)
  settingsService = inject(SettingsService)
  settings = this.mainStore.settings
  storageItem!: [string, string]
  termsText = ""
  currentRoute = ERoutes.HOME

  get exitLink() {
    return `${this.i18nStore.routePrefix}/${this.currentRoute}`
  }

  ngOnInit(): void {
    const searchParams =
      globalThis.location && new URLSearchParams(globalThis.location.search)
    this.currentRoute = (searchParams.get("current") as ERoutes) || ERoutes.HOME
    const settings = this.settings()
    if (settings) {
      const termsVersion =
        settings.settings[0].terms_and_conditions?.version ?? 6
      this.storageItem = [
        TERMS_VERSION,
        termsVersion.toString(),
      ]
    }
    this.terms$ = this.i18nStore.getLocalizedHtml("terms-and-conditions")
  }

  onAgree() {
    void this.router.navigate([this.i18nStore.routeRoot])
  }

  onCancel() {
    void this.router.navigate([this.i18nStore.routeRoot])
  }
}
